import { Injectable } from '@angular/core';
import { ColumnDefinition, ColumnDefinitions, ColumnGroup } from './column-group.class';
import { TranslationsService } from '../services/translations.service';
import { roadRiskRatingCssClass } from '../helpers/roadrisk.helpers';
import { CommonService } from '../services/common.service';

@Injectable({ providedIn: 'root' })
export class RoadRiskColumns extends ColumnGroup {
  public constructor(private translations: TranslationsService, private commonService: CommonService) {
    super();
  }

  protected columnDefinitions: ColumnDefinitions = {
    roadRiskRating: {
      width: 130,
      filterValueGetter: (params) =>
        this.translations.translate(
          `REPORTDATA.${params.getValue('roadRiskRating')}`,
          params.getValue('roadRiskRating')
        ),
      valueFormatter: (params) => this.translations.translate(`REPORTDATA.${params.value}`, params.value),
      cellClass: (params) => {
        const usesDueDates =
          this.commonService.userProfile.userPermissions?.permDueDates === this.commonService.permLevels.TRUE;
        return roadRiskRatingCssClass(
          params.api.getValue('roadRiskRating', params.node),
          usesDueDates ? params.data['roadRiskDueDate'] : null
        );
      },
    },
  };
}
